import Axios from 'axios';

export class Shortcutter {
    constructor() {
        document.querySelectorAll('a[name=setAdminShortcut]').forEach(link => {
            link.onclick = event => {
                event.preventDefault();

                Axios.post(adminPath('admin/shortcuts/toggle'), { adminMenuItemId: link.getAttribute('data-adminMenuItemId') }).then(response => {
                    window.location.reload();
                });
            };
        });
    }
}
